var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#34AADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6532 27.7571C11.6532 27.7571 25.6531 22.0115 30.5085 19.9883C32.3699 19.1791 38.6819 16.5894 38.6819 16.5894C38.6819 16.5894 41.5953 15.4566 41.3525 18.208C41.2715 19.341 40.6241 23.3062 39.9768 27.5953C39.0056 33.6647 37.9536 40.3005 37.9536 40.3005C37.9536 40.3005 37.7918 42.1618 36.4161 42.4855C35.0404 42.8092 32.7744 41.3526 32.3699 41.0288C32.0461 40.7861 26.3005 37.1444 24.1965 35.364C23.63 34.8785 22.9826 33.9075 24.2773 32.7745C27.1907 30.104 30.6704 26.7861 32.7744 24.682C33.7456 23.7109 34.7166 21.445 30.6704 24.1964C24.9248 28.1618 19.2601 31.8843 19.2601 31.8843C19.2601 31.8843 17.9653 32.6935 15.5376 31.9652C13.1098 31.2369 10.2774 30.2658 10.2774 30.2658C10.2774 30.2658 8.33532 29.0519 11.6532 27.7571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.fea3b9fe5e773f3650c50a30028afd91.svg";
export { ForwardRef as ReactComponent };